import { useStore } from "../store";
import { updateInfo } from "../info";
import { SettingContainer } from "./SettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { InputContainer } from "./InputContainer";
import { TextInput } from "./TextInput";
import { MultiLineInput } from "./MultiLineInput";
import { Button } from "./Button";

export function AnimeInfoSettings(props) {
  const { anime } = useStore();

  function onNameSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/name`, { value }, "이름", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onRomajiSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/title/romaji`, { value }, "로마자 제목", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onEnglishSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/title/english`, { value }, "영어 제목", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onJapaneseSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/title/japanese`, { value }, "일본어 제목", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onKoreanSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/title/korean`, { value }, "한국어 제목", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onDescriptionSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/description`, { value }, "설명", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onUnhide(e) {
    updateInfo(`/anime/${anime.id}/hide`, false, "애니메이션 숨김", props.onSave);
  }

  return (<>
    <SettingTitle text="애니메이션 정보"/>

    <SettingContainer>
      <SettingText text="이름"/>
      <InputContainer>
        <TextInput id="name" defaultValue={ props.anime.name } onClick={ onNameSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="로마자 제목"/>
      <InputContainer>
        <TextInput id="title-romaji" defaultValue={ props.anime.title.romaji } onClick={ onRomajiSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="영어 제목"/>
      <InputContainer>
        <TextInput id="title-english" defaultValue={ props.anime.title.english } onClick={ onEnglishSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="일본어 제목"/>
      <InputContainer>
        <TextInput id="title-japanese" defaultValue={ props.anime.title.japanese } onClick={ onJapaneseSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="한국어 제목"/>
      <InputContainer>
        <TextInput id="title-korean" defaultValue={ props.anime.title.korean } onClick={ onKoreanSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="설명"/>
      <InputContainer>
        <MultiLineInput id="description" defaultValue={ props.anime.description } onClick={ onDescriptionSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <InputContainer>
        { props.anime.deleted && <Button text="숨김 해제하기" onClick={ onUnhide }/> }
      </InputContainer>
    </SettingContainer>
  </>);
}
